import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { API_URL } from "../config";
import { SPECIALTIES } from "../SpecialtyContext";

const KIND_LABEL = { post: "Статья", case: "Клинический случай", lecture: "Материал" };
const KIND_PATH = { post: "articles", case: "cases", lecture: "lectures" };
const KIND_COLOR = { post: "#007c84", case: "#15803d", lecture: "#e5005b" };

export default function SearchResults() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q.trim()) { setItems([]); return; }
    setLoading(true);
    fetch(`${API_URL}/search?q=${encodeURIComponent(q)}&limit=30`)
      .then(r => r.ok ? r.json() : [])
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <section>
      <h2 className="section-title">Поиск{q ? `: «${q}»` : ""}</h2>

      {loading && <p style={{ color: "#888" }}>Поиск…</p>}
      {!loading && q && items.length === 0 && (
        <p style={{ color: "#999", fontStyle: "italic" }}>Ничего не найдено по запросу «{q}».</p>
      )}
      {!q && <p style={{ color: "#999", fontStyle: "italic" }}>Введите запрос в строку поиска в шапке сайта.</p>}

      {items.map(i => {
        const specialtyLabel = SPECIALTIES.find(s => s.id === i.specialty)?.label || i.specialty;
        return (
          <Link key={`${i.kind}-${i.id}`} to={`/${KIND_PATH[i.kind]}/${i.id}`} style={{ textDecoration: "none" }}>
            <div className="card">
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, flexWrap: "wrap" }}>
                <span style={{ background: KIND_COLOR[i.kind], color: "#fff", borderRadius: 6, padding: "2px 10px", fontSize: "0.78rem", fontWeight: 600 }}>
                  {KIND_LABEL[i.kind]}
                </span>
                {specialtyLabel && <span className="spec-badge">{specialtyLabel}</span>}
                <span style={{ fontSize: "0.82rem", color: "#aaa", marginLeft: "auto" }}>
                  {i.created_at ? new Date(i.created_at).toLocaleDateString("ru") : ""}
                </span>
              </div>
              <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#007c84", marginBottom: 4 }}>{i.title}</div>
              {i.snippet && <div style={{ color: "#666", fontSize: "0.92rem" }}>{i.snippet}</div>}
            </div>
          </Link>
        );
      })}
    </section>
  );
}
